import MainPage from './main';
import Single from './singlePage';

const routes = [
  {
    path: '/*',
    Component: MainPage,
    props: {},
  },
  {
    path: '/:id',
    Component: Single,
    props: {},
  },
];

export default routes;
